<template>
    <div>
        <el-form label-width="80px" :model="form" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
            <el-form-item label="缓存类型:">
                <el-select v-model="form.type" placeholder="请选择缓存类型">
                    <el-option label="memcache" value="1"></el-option>
                    <el-option label="redis" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="缓存名称:">
                <el-input v-model="form.name" placeholder="请输入缓存名称 方法与参数之间以:分隔,参数与参数之间以/分隔"></el-input>
            </el-form-item>
            <el-form-item label="缓存值:">
                <el-input v-model="form.value"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onQuery">查询</el-button>
                <el-button type="primary" @click="onUpdate">更新</el-button>
                <el-button type="primary" @click="onDelete">删除</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>

    //导入 HTTP请求方法
    import {getCache,updateCache,deleteCache} from '../../api/api'

    export default{
        data(){
            return {
                form:{
                    type:'1',
                    name:'',
                    value:''
                }
            }
        },
        methods:{
            onQuery(){
                getCache(this.form).then((res) => {
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });
                        this.form.value = res.data.value;
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            onUpdate(){
                const loading = this.$loading(this.GCONFIG.loadingParam);
                updateCache(this.form).then((res) => {
                    loading.close();
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            onDelete(){
                const loading = this.$loading(this.GCONFIG.loadingParam);
                deleteCache(this.form).then((res) => {
                    loading.close();
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '删除成功',
                            type: 'success'
                        });
                        this.form.value ='';
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/system/system.vue